import React from 'react'
import spinner from "./../../assets/spinner.svg"

const LoadingPage = () => {
    return (
        <div className="container">
            <div className="flex select-none justify-center items-center h-96">
                <div className="flex flex-col ">
                    <img src={spinner} alt="" />
                    {/* <p className="text-3xl font-medium text-center">
                    <Typewriter onInit={typewriter => {
                        typewriter.typeString("Loading...").pauseFor(2000).start().deleteAll().start()
                    }} />
                </p> */}
                </div>
            </div>
        </div>
    )
}

export default LoadingPage